// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1SyFN","file":"styles_file__3a9n3"};